<div class="card">
    <h2>{{ 'exports.imports-runner.header' | translate }}</h2>
    <div class="cardContent" [formGroup]="form">
        <div class="inputGroup">
            <label for="channel">{{ 'exports.imports-runner.labels.channel' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error
                    [parentForm]="form"
                    [controlPath]="'channelId'"
                    [controlLabel]="'exports.imports-runner.labels.channel' | translate"
                />
                @let eligibleChannels = channelsService.importsEligibleChannels();
                @if (eligibleChannels) {
                    <select id="exportType" formControlName="channelId">
                        @for (channel of eligibleChannels; track channel.value) {
                            <option [value]="channel.value">{{ channel.label }}</option>
                        }
                    </select>
                }
            </div>
        </div>
        <div class="inputGroup">
            <label for="supplier">{{ 'exports.imports-runner.labels.supplier' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error
                    [parentForm]="form"
                    [controlPath]="'supplierId'"
                    [controlLabel]="'exports.imports-runner.labels.supplier' | translate"
                />
                @let suppliers = suppliersService.allSuppliersList();
                @if (suppliers) {
                    <app-typeahead-select
                        formControlName="supplierId"
                        class="formControl"
                        [id]="'supplierId'"
                        [optionsList]="suppliers"
                        [idKey]="'id'"
                        [labelKey]="'companyName'"
                    />
                }
            </div>
        </div>
        <div class="inputGroup">
            <label for="brand">{{ 'exports.imports-runner.labels.brand' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error
                    [parentForm]="form"
                    [controlPath]="'brandId'"
                    [controlLabel]="'exports.imports-runner.labels.brand' | translate"
                />
                @let brandsList = suppliersService.brandListBySupplier();
                @if (brandsList) {
                    <select id="exportType" formControlName="brandId">
                        @for (brand of brandsList; track brand.value) {
                            <option [value]="brand.value">{{ brand.label }}</option>
                        }
                    </select>
                }
            </div>
        </div>
        <div class="importItemsWrapper">
            <div class="inputGroup noBorder" [formGroup]="addImportItemForm">
                <label>{{ 'exports.imports-runner.labels.importItems' | translate }}</label>
                <div class="inputWrapper">
                    <div class="addImportItemInputs">
                        <div class="inputContainer">
                            <label for="channelMappedId">{{ 'exports.imports-runner.labels.channelMappedId' | translate }}</label>
                            <input type="text" formControlName="channelMappedId" />
                            <app-form-error [parentForm]="addImportItemForm" [controlPath]="'channelMappedId'" />
                        </div>

                        <div class="inputContainer">
                            <div class="labelWithTooltip">
                                <label for="listingId">{{ 'exports.imports-runner.labels.listing' | translate }}</label>
                                <i
                                    appTooltip
                                    class="far fa-info-circle"
                                    trigger="hover"
                                    position="right"
                                    [showDelay]="100"
                                    [hideDelay]="100"
                                    [componentData]="'exports.imports-runner.importItems.listingSelectorTooltip' | translate"
                                ></i>
                            </div>
                            <app-typeahead-select
                                formControlName="listingId"
                                [optionsList]="supplierListingOptions()"
                                [idKey]="'id'"
                                [labelKey]="'name'"
                                [showEmptyOption]="true"
                                [emptyOptionLabel]="'exports.imports-runner.importItems.createNewListingPlaceholder' | translate"
                            />
                            <app-form-error [parentForm]="addImportItemForm" [controlPath]="'listingId'" />
                        </div>

                        <div class="formErrorContainer">
                            <app-form-error [parentForm]="addImportItemForm" [showError]="addImportItemForm.invalid" />
                        </div>

                        <div class="addButtonsContainer">
                            <button
                                class="button primary icon"
                                (click)="addNewListingMapping()"
                                [disabled]="!isImportItemAddAllowed() || addImportItemForm.invalid"
                            >
                                <i class="fa fa-plus"></i>
                                <span>{{ 'generalKeywords.add' | translate }}</span>
                            </button>

                            <button class="button secondary" (click)="openBulkAddModal()" [disabled]="!isImportItemAddAllowed()">
                                <span>{{ 'exports.imports-runner.importItems.addBulkButtonText' | translate }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            @if (importItemsData().length) {
                <div class="importItemList" [formGroup]="form">
                    <app-data-grid [data]="importItemsData()" [columns]="importItemColumns" />
                </div>
            }
        </div>
    </div>
    <div class="buttonArea">
        <button class="button primary" (click)="runImport()" [disabled]="!formValid()">
            {{ 'exports.imports-runner.runImport' | translate }}
        </button>
    </div>
</div>
